import React from "react";

export const LoadingState: React.FC<{ message?: string }> = ({
  message = "Loading analytics…",
}) => (
  <div className="an-state">
    <div className="an-spinner" />
    <span>{message}</span>
  </div>
);

export const ErrorState: React.FC<{ message?: string; onRetry?: () => void }> = ({
  message,
  onRetry,
}) => (
  <div className="an-state an-state--error">
    <h3 className="an-state-title">Couldn't load this data</h3>
    {message && <p>{message}</p>}
    {onRetry && (
      <button className="an-button an-button--primary" onClick={onRetry}>
        Retry
      </button>
    )}
  </div>
);

export const EmptyState: React.FC<{ title?: string; message?: string }> = ({
  title = "No data for this range",
  message = "Try widening the date range or clearing filters.",
}) => (
  <div className="an-state">
    <h3 className="an-state-title">{title}</h3>
    <p>{message}</p>
  </div>
);
